
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos-hardware-partners/pinelabs",
      function () {
        return require("private-next-pages/pos-hardware-partners/pinelabs.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos-hardware-partners/pinelabs"])
      });
    }
  